import { AdInformationInterface, AdTargetingInterface, BreadcrumbInterface, PageInformationInterface, PianoSwitchConfigurationInterface, SeoItemInterface, TrackingInformationCustomVarsInterface, TrackingInformationInterface } from "./PageInformationInterface"
import { getTeaserEntries } from "./ressort"

export function getPageInformation(entry): PageInformationInterface {
  let seoItems: SeoItemInterface[] = []
  if(entry.pageInformation) {
    if(entry.pageInformation.metaInformation) {
      if(entry.pageInformation.metaInformation.description) {
        const seoEntry: SeoItemInterface = {
              property: "description",
              content: entry.pageInformation.metaInformation.description
            }
          seoItems.push(seoEntry)
      }
      if(entry.pageInformation.metaInformation.keywords) {
        const seoEntry: SeoItemInterface = {
              property: "keywords",
              content: entry.pageInformation.metaInformation.keywords
            }
          seoItems.push(seoEntry)
      }
      if(entry.pageInformation.metaInformation.title) {
        const seoEntry: SeoItemInterface = {
              property: "title",
              content: entry.pageInformation.metaInformation.title
        }
        seoItems.push(seoEntry)
      }
    }
  }

  let ogItems: SeoItemInterface[] = []
  if(entry.ogProperties) {
    Object.entries(entry.ogProperties).forEach(
      ([key, value]) => {
        const ogEntry: SeoItemInterface = {
          property: key,
          content: value as string
        }
        ogItems.push(ogEntry)
      }
    )
  }

  let trackingInformation: TrackingInformationInterface = {}

  let pianoSwitchConfiguration: PianoSwitchConfigurationInterface = {
    paywallOff: false,
    pianoOff: false
  }

  let adInformation: AdInformationInterface = {
    hideRecommendationAd: false,
    dfpAdUrl: "",
    clientAlias: "",
    css: "",
    targeting: []
  }

  let breadcrumbs: BreadcrumbInterface[] = []
  if(entry.pageInformation) {

    if(entry.pageInformation.pianoSwitchConfiguration) {
      pianoSwitchConfiguration.paywallOff = entry.pageInformation.pianoSwitchConfiguration.paywallOff == true
      pianoSwitchConfiguration.pianoOff = entry.pageInformation.pianoSwitchConfiguration.pianoOff == true
    }

    if(entry.pageInformation.trackingInformation) {
      
      if(entry.pageInformation.trackingInformation.site) {
        trackingInformation.site = entry.pageInformation.trackingInformation.site.toString()
      }
      if(entry.pageInformation.trackingInformation.article) {
        trackingInformation.article = entry.pageInformation.trackingInformation.article
      }
      if(entry.pageInformation.trackingInformation.articleTypes) {
        trackingInformation.articleTypes = entry.pageInformation.trackingInformation.articleTypes
      }
      if(entry.pageInformation.trackingInformation.authors) {
        trackingInformation.authors = entry.pageInformation.trackingInformation.authors
      }
      if(entry.pageInformation.trackingInformation.branding) {
        trackingInformation.branding = entry.pageInformation.trackingInformation.branding
      }

      if(entry.pageInformation.trackingInformation.editorialTeams) {
        trackingInformation.editorialTeams = entry.pageInformation.trackingInformation.editorialTeams
      }

      if(entry.pageInformation.trackingInformation.categories1) {
        trackingInformation.categories1 = entry.pageInformation.trackingInformation.categories1
      }
      if(entry.pageInformation.trackingInformation.categories2) {
        trackingInformation.categories2 = entry.pageInformation.trackingInformation.categories2
      }

      if(entry.pageInformation.trackingInformation.cities) {
        trackingInformation.cities = entry.pageInformation.trackingInformation.cities
      }

      if(entry.pageInformation.trackingInformation.containsContentTypes) {
        trackingInformation.containsContentTypes = entry.pageInformation.trackingInformation.containsContentTypes
      }

      if(entry.pageInformation.trackingInformation.advertorial == true || entry.pageInformation.trackingInformation.advertorial === false) {
        trackingInformation.advertorial = entry.pageInformation.trackingInformation.advertorial
      }

      if(entry.pageInformation.trackingInformation.contentId) {
        trackingInformation.contentId = entry.pageInformation.trackingInformation.contentId
      }
      if(entry.pageInformation.trackingInformation.contentType) {
        trackingInformation.contentType = entry.pageInformation.trackingInformation.contentType
      }

      if(entry.pageInformation.trackingInformation.dpaCode) {
        trackingInformation.dpaCode = entry.pageInformation.trackingInformation.dpaCode
      }

      if(entry.pageInformation.trackingInformation.page) {
        trackingInformation.page = entry.pageInformation.trackingInformation.page
      }

      if(entry.pageInformation.trackingInformation.paidContent) {
        trackingInformation.paidContent = entry.pageInformation.trackingInformation.paidContent
      }

      if(entry.pageInformation.trackingInformation.priority) {
        trackingInformation.priority = entry.pageInformation.trackingInformation.priority
      }

      if(entry.pageInformation.trackingInformation.regions) {
        trackingInformation.regions = entry.pageInformation.trackingInformation.regions
      }

      if(entry.pageInformation.trackingInformation.subSections) {
        trackingInformation.subSections = entry.pageInformation.trackingInformation.subSections
      }

      if(entry.pageInformation.trackingInformation.page) {
        trackingInformation.page = entry.pageInformation.trackingInformation.page
      }
      if(entry.pageInformation.trackingInformation.priority) {
        trackingInformation.priority = entry.pageInformation.trackingInformation.priority
      }

      if(entry.pageInformation.trackingInformation.siteLevel2) {
        trackingInformation.siteLevel2 = entry.pageInformation.trackingInformation.siteLevel2
      }

      if(entry.pageInformation.trackingInformation.firstPublication) {
        trackingInformation.firstPublication = entry.pageInformation.trackingInformation.firstPublication
      }
      if(entry.pageInformation.trackingInformation.lastPublication) {
        trackingInformation.lastPublication = entry.pageInformation.trackingInformation.lastPublication
      }

      trackingInformation.affiliate = entry.pageInformation.trackingInformation.affiliate == true

      if(entry.pageInformation.trackingInformation.topic) {
        trackingInformation.topic = entry.pageInformation.trackingInformation.topic
      }

      if(entry.pageInformation.trackingInformation.topline) {
        trackingInformation.topline = entry.pageInformation.trackingInformation.topline
      }

      if(entry.pageInformation.trackingInformation.sections) {
        trackingInformation.sections = entry.pageInformation.trackingInformation.sections
      }
    }

    if(entry.pageInformation.advertInitialization) {
      adInformation.hideRecommendationAd = entry.pageInformation.advertInitialization.hideRecommendationAd
      if(entry.pageInformation.advertInitialization.configuration && entry.pageInformation.advertInitialization.configuration.dfpAdUrl) {
        adInformation.dfpAdUrl = entry.pageInformation.advertInitialization.configuration.dfpAdUrl
      }

      if(entry.pageInformation.advertInitialization.configuration && entry.pageInformation.advertInitialization.configuration.clientAlias) {
        adInformation.clientAlias = entry.pageInformation.advertInitialization.configuration.clientAlias
      }

      if(entry.pageInformation.advertInitialization.css) {
        adInformation.css = entry.pageInformation.advertInitialization.css
      }
      
      if(entry.pageInformation.advertInitialization.configuration && 
        entry.pageInformation.advertInitialization.configuration.targeting&& 
        entry.pageInformation.advertInitialization.configuration.targeting.length > 0) {
          for (let row of entry.pageInformation.advertInitialization.configuration.targeting) {
            const rowEntry: AdTargetingInterface = {
              key: row.key,
              value: row.value,
              values: row.values
            }
            adInformation.targeting.push(rowEntry)
          }
          adInformation.targeting.push({
            key: "channel",
            value: "mobile_app",
            values: ""
          })
      }
    }

    
    if(entry.pageInformation) {
      if(entry.pageInformation.breadcrumbs && entry.pageInformation.breadcrumbs.length > 0) {
        for (let row of entry.pageInformation.breadcrumbs) {
          const breadcrumbEntry: BreadcrumbInterface = {
            id: row.id ?? null,
            showIcon: row.showIcon == true,
            name: row.name ?? null,
            trendingTopics: getTeaserEntries(row),
            links: row.links ?? []
          }
          breadcrumbs.push(breadcrumbEntry)
        }
      }
    }
  }

  let pageInformationInterface: PageInformationInterface = {
    seoItems: seoItems,
    ogItems: ogItems,
    pianoSwitchConfiguration: pianoSwitchConfiguration,
    trackingInformation: trackingInformation,
    breadcrumbs: breadcrumbs,
    adInformation: adInformation
  }

  return pageInformationInterface
}